import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HotelDetail from "@/pages/customer/HotelDetail";
import CustomerHeader from "@/components/customer/CustomerHeader";
import { http } from "@/lib/api";

export const MAIN_HOST = new URL(process.env.REACT_APP_BACKEND_URL).hostname;
export const isCustomHost = () => !["localhost", "127.0.0.1", MAIN_HOST].includes(window.location.hostname);

export default function PropertySite() {
  const { slug } = useParams();
  const [pid, setPid] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    http.get("/public/resolve", { params: { slug } }).then((r) => setPid(r.data.id)).catch(() => setErr(true));
  }, [slug]);
  if (err) return <div className="min-h-screen bg-[#F7F4EF]"><CustomerHeader /><p data-testid="property-site-error" className="p-10 text-center text-red-600">Properti tidak ditemukan</p></div>;
  return pid ? <HotelDetail propertyId={pid} /> : null;
}
